import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_PROVIDER_SPECIALTY,
  CREATE_PROVIDER_SPECIALTY,
  UPDATE_PROVIDER_SPECIALTY,
  DELETE_PROVIDER_SPECIALTY,
  GET_PROVIDER_SPECIALTY_BY_ID,
} from './actionType';

// common success
export const ProviderSpecialtyApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const ProviderSpecialtyApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetProviderSpecialty = (id) => ({
  type: GET_PROVIDER_SPECIALTY,
  payload: { id },
});

export const GetProviderSpecialtyById = (id) => ({
  type: GET_PROVIDER_SPECIALTY_BY_ID,
  payload: { id },
});

export const CreateProviderSpecialty = (data, history) => ({
  type: CREATE_PROVIDER_SPECIALTY,
  payload: { data, history },
});

export const UpdateProviderSpecialty = (id, data, history) => ({
  type: UPDATE_PROVIDER_SPECIALTY,
  payload: { id, data, history },
});

export const DeleteProviderSpecialty = (id) => ({
  type: DELETE_PROVIDER_SPECIALTY,
  payload: { id },
});
